// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsHeader-cls1_Df4","cls2":"TasteOfMentionsHeader-cls2_kNf TasteOfMentionsHeader-cls1_Df4"};